module.exports = __webpack_public_path__ + "img/SES_192425255.47498d5b.jpg";